// extracted by mini-css-extract-plugin
export default {"sub_nav":"index_sub_nav_rd6xj"};